import { Link } from "react-router-dom";
import { NewsletterForm } from "@/components/NewsletterForm";

const NAV_ITEMS = [
  { to: "/about", label: "About" },
  { to: "/our-work", label: "Our Work" },
  { to: "/our-people", label: "Our People" },
  { to: "/stories-culture", label: "Stories & Culture" },
  { to: "/stories-move", label: "Stories Move" },
  { to: "/connect", label: "Connect" },
];

export const Footer = () => {
  return (
    <footer className="bg-white text-[#121212] pt-16 pb-12 border-t border-[#e5e5e5]">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16 border-b border-[#e5e5e5]">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-4">
              <img src="/brand/logo.webp" alt="#whatshesaidproject" className="h-9 w-auto" />
            </div>
            <p
              data-testid="footer-tagline"
              className="text-sm text-[#555555] leading-relaxed mb-6 font-disp italic"
            >
              “From the street to the statehouse and from the page to the stage.”
            </p>
            <p className="text-xs text-[#6b6b6b] font-mono leading-relaxed">
              A mission-led creative &amp; cultural organization. Not a political organization or
              an advocacy campaign agency.
            </p>
          </div>

          <div className="md:col-span-7 flex flex-col justify-between gap-10">
            <div>
              <span className="text-xs font-mono uppercase tracking-[.18em] text-[#e02020] block mb-2">
                Stay Connected
              </span>
              <h3 className="font-disp text-2xl text-[#121212] mb-3">
                The Dispatch
              </h3>
              <p className="text-sm text-[#555555] mb-6">
                Occasional essays, programming releases, talent announcements, and event
                invitations directly in your inbox.
              </p>
              <NewsletterForm />
            </div>
          </div>
        </div>

        <div className="pt-10 flex flex-col md:flex-row justify-between gap-6">
          <nav aria-label="Footer" className="flex flex-wrap gap-x-7 gap-y-3">
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                data-testid={`footer-link-${item.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="text-xs font-mono uppercase tracking-[.14em] text-[#555555] hover:text-[#e02020] transition-colors"
              >
                {item.label}
              </Link>
            ))}
          </nav>
          <p className="text-xs font-mono text-[#6b6b6b]">
            © {new Date().getFullYear()} #whatshesaidproject. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
